export default "__VITE_ASSET__85362001__"